import { cn } from "../../lib/utils";

export function BetaBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide",
        "bg-amber-100 text-amber-800 border border-amber-200/80",
        className
      )}
    >
      Beta
    </span>
  );
}
